module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, 'waiting-for-filter': _vm.isAwaitingFilter
    }
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('transition-group', {
    staticClass: "animate-list",
    attrs: {
      "name": "animate-list",
      "tag": "ul",
      "aria-label": "Lista över boendeområden"
    }
  }, [(!_vm.SITE_CONFIG.modules_open.accomodation.open) ? _c('li', {
    key: -2,
    class: 'animate-list-item no-results result-count-0'
  }, [_c('b', [_vm._v("Stängt")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.accomodation.closed_message))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredPools), function(pool, index) {
    return _c('li', {
      key: pool.id,
      staticClass: "animate-list-item area-wrapper",
      attrs: {
        "aria-label": 'Område: ' + (pool.display_name || pool.name)
      }
    }, [(_vm.areaTitle(pool, index)) ? _c('div', {
      staticClass: "list-header"
    }, [_c('span', [_vm._v(_vm._s(_vm.areaTitle(pool, index)))])]) : _vm._e(), _vm._v(" "), _c('AccomodationsListPool', {
      attrs: {
        "pool": pool,
        "locations": _vm.locations
      }
    })], 1)
  }), _vm._v(" "), _c('li', {
    key: -1,
    class: 'animate-list-item no-results result-count-' + _vm.filteredPools.length,
    attrs: {
      "role": "note"
    }
  }, [_c('strong', [_vm._v("Dina filterval gav ingen träff")]), _vm._v(" "), _c('p', [_vm._v("Dina filterval gav ingen träff, ta bort filter eller återställ och börja om.")])])], 2) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "margin-top"
  }, [_c('li', [(_vm.$store.state.accomodationsFilter.freeSearch) ? _c('AccomodationsListUnitsList', {
    attrs: {
      "units": _vm.allUnits
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b770d922"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/AccomodationsList.vue
// module id = 998
// module chunks = 0